import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useFocusRing } from "@react-aria/focus";
import styled, { css } from "styled-components";
import { token } from "./token.js";
import { Tooltip } from "./Tooltip.js";
const ContextActionButton = forwardRef(({
  children,
  isDisabled = false,
  isPressed = false,
  tooltip,
  "aria-label": ariaLabel,
  ...props
}, ref) => {
  const {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  const Button = /* @__PURE__ */ jsx(ContextActionButtonStyled, {
    disabled: isDisabled,
    type: "button",
    $isFocusVisible: isFocusVisible,
    ref,
    $isPressed: isPressed,
    "aria-label": ariaLabel,
    ...focusProps,
    ...props,
    children
  });
  return tooltip ? /* @__PURE__ */ jsx(Tooltip, {
    timing: "delay",
    content: tooltip,
    children: Button
  }) : Button;
});
const ContextActionButtonStyled = styled.button.withConfig({
  displayName: "ContextActionButtonStyled",
  componentId: "sc-1m1kqdv-0"
})(["display:inline-flex;vertical-align:middle;flex-wrap:nowrap;justify-content:center;align-items:center;box-sizing:border-box;min-width:40px;height:32px;padding:0 ", ";border:none;border-radius:", ";background-color:transparent;box-shadow:0 0 0 1px ", ";font-weight:400;font-style:normal;font-size:", ";font-family:", ";line-height:", ";letter-spacing:normal;text-align:center;text-decoration:none;white-space:nowrap;cursor:pointer;fill:currentcolor;transition-duration:0.1s;transition-property:background-color,border-color,box-shadow,color;", ""], token.spacing3, token.brandRadiusBase, token.gray100a, token.fontSize75, token.brandFontStackBase, token.lineHeightBase, (props) => {
  const pressedStyles = css(["background-color:", ";color:", ";box-shadow:0 0 0 1px ", ";"], token.gray10, token.gray800, token.gray100a);
  return css(["background-color:rgb(", " / 90%);color:", ";", " &:hover{background-color:", ";color:", ";box-shadow:", ",", ";}&:active{", "}&:disabled{background-color:rgb(", " / 70%);color:", ";box-shadow:0 0 0 1px ", ";cursor:default;}"], token["white-rgb"], token.gray600a, props.$isPressed && pressedStyles, token.gray10, token.gray800, token.elevation1, token.elevationStatic, pressedStyles, token["white-rgb"], token.gray200a, token.gray100a);
});
export {
  ContextActionButton
};
//# sourceMappingURL=ContextActionButton.js.map
